// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyApGwL5r85E9Cv3NUTGqkDQyt9s17Wicxc",
  authDomain: "saivaniapp.firebaseapp.com",
  projectId: "saivaniapp",
  storageBucket: "saivaniapp.appspot.com",
  messagingSenderId: "124519049279",
  appId: "1:124519049279:web:60aeb588a8123145f3f08a"
};

// Initialize Firebase
export default firebaseConfig;